import TablaConciliacion from "../../../TablaConciliacion";

function TablaYuma() {
  return <TablaConciliacion nombreUseCase="YUMA" titulo="YUMA" />;
}

export default TablaYuma;
